import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import { TABLE_KEY_FIELD } from '../configs'

export const getExpandedKeys = (data: ISobCompetitorsGroup[]) => {
  return data.filter((el) => el.IsExpanded)?.map((el) => el[TABLE_KEY_FIELD])
}
